import { DiscountCodesFilters } from "@ac-expo/api-types";

const acExpoDiscountCodeQueryKey = {
  all: ["discount-codes-acexpo"] as const,
  lists: (filters: DiscountCodesFilters) =>
    [...acExpoDiscountCodeQueryKey.all, "lists", filters] as const,
  details: () => [...acExpoDiscountCodeQueryKey.all, "details"] as const,
  detail: (equipmentId: string) =>
    [...acExpoDiscountCodeQueryKey.details(), equipmentId] as const,
};

export default acExpoDiscountCodeQueryKey;
